/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ShiftFilterType } from "src/client/react/src/staffhub/sh-models";
import schedulesViewStateStore from "../store/store";
import { mutatorAction } from "satcheljs";

/**
 * Sets the selected shift filter
 * @param selectedShiftFilter the selected shift filter
 * @param isEnabled whether the filter is enabled or not
 */
export const setSelectedShiftFilter = mutatorAction(
    "setSelectedShiftFilter",
    (selectedShiftFilter: ShiftFilterType, isEnabled: boolean) => {
        const { selectedShiftFilters } = schedulesViewStateStore();

        if (isEnabled && !selectedShiftFilters.has(selectedShiftFilter)) {
            selectedShiftFilters.set(selectedShiftFilter.toString(), selectedShiftFilter);
        } else if (!isEnabled && selectedShiftFilters.has(selectedShiftFilter)) {
            selectedShiftFilters.delete(selectedShiftFilter);
        }
    }
);